// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"TabImgEu_TheComp__12a7s"};